module.exports = __webpack_public_path__ + "img/RonZacapa12anos.d16b775a.jpg";